import { render } from "./Crear-Solicitud.vue?vue&type=template&id=1443bc8d&scoped=true"
import script from "./Crear-Solicitud.vue?vue&type=script&lang=js"
export * from "./Crear-Solicitud.vue?vue&type=script&lang=js"

import "./Crear-Solicitud.vue?vue&type=style&index=0&id=1443bc8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1443bc8d"]])

export default __exports__